import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { alertErrorMessage, alertSuccessMessage } from "../../../customComponents/CustomAlertMessage";

const buildReferralLink = (referralCode) =>
  `${window.location.origin}/signup?referral_code=${encodeURIComponent(referralCode)}`;

const buildReferralShareText = (referralLink) =>
  `Join me on ARAB Global Exchange and earn up to 40% commission! Sign up here: ${referralLink}`;

const DashboardRightSidebar = ({ userDetails = {} }) => {
  const navigate = useNavigate();
  const referralCode = userDetails?.referral_code || "--";
  const has2FA = Number(userDetails?.["2fa"]) === 1;
  const [shareMenuOpen, setShareMenuOpen] = useState(false);
  const shareMenuRef = useRef(null);

  const referralLink = buildReferralLink(referralCode);
  const referralShareText = buildReferralShareText(referralLink);
  const hasReferralCode = referralCode && referralCode !== "--";

  useEffect(() => {
    if (!shareMenuOpen) return;

    const handleOutsideClick = (event) => {
      if (shareMenuRef.current && !shareMenuRef.current.contains(event.target)) {
        setShareMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [shareMenuOpen]);

  const copyReferralLink = async () => {
    if (!hasReferralCode) {
      alertErrorMessage("Referral code not available");
      return;
    }

    try {
      await navigator.clipboard.writeText(referralLink);
      alertSuccessMessage("Referral link copied");
      setShareMenuOpen(false);
    } catch {
      alertErrorMessage("Unable to copy referral link");
    }
  };

  const openShareWindow = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
    setShareMenuOpen(false);
  };

  const handleShareReferralLink = async () => {
    if (!hasReferralCode) {
      alertErrorMessage("Referral code not available");
      return;
    }

    const shareData = {
      title: "Join ARAB Global Exchange",
      text: referralShareText,
      url: referralLink,
    };

    if (navigator.share) {
      try {
        await navigator.share(
          navigator.canShare?.(shareData) ? shareData : { text: referralShareText }
        );
        return;
      } catch (error) {
        if (error?.name === "AbortError") return;
      }
    }

    setShareMenuOpen((open) => !open);
  };

  return (
    <div className="dashboard_right_side">
      <div className="vip_servies">
        <h6>
          <img src="/images/vip_vector.svg" alt="VIP Services" /> VIP Services
        </h6>

        <ul className="vip_services_list">
          <li>Lower trading fees & priority support</li>
          <li>Higher withdrawal limits & faster withdrawals</li>
          <li>Personal account manager</li>
        </ul>

        <button
          type="button"
          className="vip_btn"
          onClick={() => navigate("/vip-services")}
        >
          Upgrade to VIP
        </button>
      </div>

      {/* <div className="announcements_right">
        <div className="announcements_card">
          <div className="announcements_top">
            <div className="announcements_title">
              <i className="ri-notification-3-line" aria-hidden />
              <h4>Announcements</h4>
            </div>
            <Link className="announcements_viewall" to="/announcement">
              View All
            </Link>
          </div>

          <div className="announcement_block">
            <Link className="announcement_item" to="/announcement">
              <div className="announcement_item_left">
                <p className="announcement_item_title">
                  New trading pairs listed: SOL/USDT
                </p>
                <span className="announcement_item_time">2 hours ago</span>
              </div>
              <i className="ri-arrow-right-s-line" aria-hidden />
            </Link>

            <div className="announcement_divider" role="separator" />

            <Link className="announcement_item" to="/announcement">
              <div className="announcement_item_left">
                <p className="announcement_item_title">
                  System maintenance scheduled
                </p>
                <span className="announcement_item_time">1 day ago</span>
              </div>
              <i className="ri-arrow-right-s-line" aria-hidden />
            </Link>
          </div>
        </div>
      </div> */}

      {/* <div className="new_features_s">
        <div className="features_block">
          <Link className="block_features" to="#">
            <div className="features_cnt">
              <h5>
                Download AGCX App{" "}
                <span>
                  <i className="ri-arrow-right-s-line" />
                </span>
              </h5>

              <div className="d-flex justify-content-between agcf_block_midle">
                <div className="agcf">
                  <h6>AGCX</h6>
                  <span>Scan to download</span>
                </div>

                <div className="agcf_img">
                  <img src="/images/agcf_vector.svg" alt="AGCX App" />
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div> */}

      <div className="dashboard_right_cards">
        <div className="dashboard_simple_card referral_program_card">
          <div className="dash_card_header">
            <div className="dash_card_icon dash_card_icon--muted">
              <i className="ri-gift-line" aria-hidden />
            </div>
            <h4>Referral Program</h4>
          </div>

          <p className="dash_card_desc">
            Invite friends and earn up to 40% commission
          </p>

          <div className="dash_code_pill">
            <span className="dash_code_text">{referralCode}</span>
            <button
              type="button"
              className="dash_code_copy"
              aria-label="Copy referral code"
              onClick={() => {
                navigator.clipboard.writeText(referralCode);
                alertSuccessMessage("Referral code copied");
              }}
            >
              <i className="ri-file-copy-line" aria-hidden />
            </button>
          </div>

          <div className="dash_share_wrap" ref={shareMenuRef}>
            <button
              type="button"
              className="dash_outline_btn"
              onClick={handleShareReferralLink}
            >
              Share Link
            </button>

            {shareMenuOpen && (
              <div className="dash_share_menu" role="menu" aria-label="Share referral link">
                <button
                  type="button"
                  className="dash_share_option"
                  onClick={() =>
                    openShareWindow(`https://wa.me/?text=${encodeURIComponent(referralShareText)}`)
                  }
                >
                  <i className="ri-whatsapp-line" aria-hidden /> WhatsApp
                </button>
                <button
                  type="button"
                  className="dash_share_option"
                  onClick={() =>
                    openShareWindow(
                      `https://t.me/share/url?url=${encodeURIComponent(referralLink)}&text=${encodeURIComponent("Join me on ARAB Global Exchange!")}`
                    )
                  }
                >
                  <i className="ri-telegram-line" aria-hidden /> Telegram
                </button>
                <button
                  type="button"
                  className="dash_share_option"
                  onClick={() =>
                    openShareWindow(
                      `https://twitter.com/intent/tweet?text=${encodeURIComponent(referralShareText)}`
                    )
                  }
                >
                  <i className="ri-twitter-x-line" aria-hidden /> X
                </button>
                <button
                  type="button"
                  className="dash_share_option"
                  onClick={() =>
                    openShareWindow(
                      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(referralLink)}`
                    )
                  }
                >
                  <i className="ri-facebook-circle-line" aria-hidden /> Facebook
                </button>
                <button type="button" className="dash_share_option" onClick={copyReferralLink}>
                  <i className="ri-file-copy-line" aria-hidden /> Copy Link
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="dashboard_simple_card security_center_card">
          <div className="dash_card_header">
            <div className="dash_card_icon dash_card_icon--green">
              <i className="ri-shield-check-line" aria-hidden />
            </div>
            <h4>Security Center</h4>
          </div>

          <p className="dash_card_desc">
            {has2FA ? "Two-factor authentication is enabled" : "Enable 2FA for enhanced security"}
          </p>

          <Link
            className="dash_primary_btn dash_primary_btn--green"
            to="/user_profile/security"
          >
            {has2FA ? "Manage 2FA" : "Enable 2FA"}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DashboardRightSidebar;
